import { C } from "@/brand/tokens";
import { brand6 } from "@/brand/contentF6";
import { Cta6 } from "@/components/common/Cta6";

/** CtaBand6 — closing consultation band for interior pages (blue or ink). */
export function CtaBand6({
  eyebrow = "Start a confidential conversation",
  headline = "Bring the situation into view.",
  label = brand6.ctaLabel,
  to = "/contact",
  tone = "blue",
  testId = "cta-band",
}) {
  return (
    <section data-testid={testId} style={{ background: tone === "ink" ? C.bgDark : C.surfacePrimary, color: C.textOnDark }}>
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-12 py-16 lg:py-20 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div>
          <p className="font-inter text-[11px] uppercase font-semibold" style={{ color: C.accentMetal, letterSpacing: "0.28em" }}>
            {eyebrow}
          </p>
          <h3 className="mt-4 font-cormorant" style={{ color: C.textOnDark, fontSize: "clamp(1.5rem, 2.4vw, 2rem)", fontWeight: 400, lineHeight: 1.1 }}>
            {headline}
          </h3>
        </div>
        <Cta6 to={to} variant="light" testId={`${testId}-btn`} className="px-7 py-4">
          {label}
        </Cta6>
      </div>
    </section>
  );
}
